import { TableCard } from '../../../../components'
import { ClienteHeading } from '../empresasCliente-list/components/ClienteHeading'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { CoordenadorClienteTable } from './table/CoordenadorClienteTable'
import { CoordenadorClienteListHeader } from './components/header/CoordenadorClienteListHeader'

const CoordenadorClienteList = () => {
  return (
    <>
      <ClienteHeading />
      <TableCard>
        <CoordenadorClienteListHeader />
        <CoordenadorClienteTable />
      </TableCard>
    </>
  )
}

export const CoordenadorClienteListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListFiltersProvider>
        <CoordenadorClienteList />
      </ListFiltersProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
